/**
 * Component types excluded from custom page rendering.
 * These don't have sortOrder or aren't valid custom page components.
 * RsvpAndUnlockGuestDetailsButtonComponent is now handled as a JSON component.
 * TODO: Remove this once these components are removed from the BE response.
 */
const INVALID_COMPONENT_TYPES = [
  'GreetingMessageComponent',
  'EventDisplayNameComponent',
  'RsvpAndUnlockGuestDetailsButtonComponent',
  'EventCountdownComponent',
  'EventDetailsComponent',
] as const;

export type PagesToExclude =
  | { __typename?: 'EventDisplayNameComponent' }
  | { __typename?: 'GreetingMessageComponent' }
  | { __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent' }
  | { __typename?: 'EventCountdownComponent' }
  | { __typename?: 'EventDetailsComponent' };

/**
 * Generic type guard for filtering out invalid component types from custom page component arrays.
 * Used by both the guest Custom widget and the admin CustomComponents editor.
 */
export const filterInvalidComponents = <T extends { __typename?: string }>(component: T): component is Exclude<T, PagesToExclude> => {
  return !INVALID_COMPONENT_TYPES.includes(component.__typename as (typeof INVALID_COMPONENT_TYPES)[number]);
};
